import InventoryTransactionPage from "../../InventoryTransactionPage";

const InventorySalesOrder = () => <InventoryTransactionPage title="Sales Order" step={4} description="Create and manage customer orders that reserve inventory for sale." />;

export default InventorySalesOrder;
